// Escape-exits-fullscreen is a browser-level action, not a cancellable keydown
// default — preventDefault() in a keydown handler cannot stop it (unlike the
// shortcuts in browserShortcuts.js). The Keyboard Lock API is the one platform
// hook built for this: once locked, a single Escape tap is delivered to the page
// like any other keypress (existing per-component Escape handlers keep working)
// instead of exiting fullscreen. Chromium-only (Chrome/Edge/Opera); unsupported
// browsers (Firefox, Safari) silently keep the default single-tap exit. A
// press-and-hold of Escape (~2s) still force-exits even when locked — the browser
// guarantees this so users are never trapped in fullscreen.
export async function enterFullscreenWithEscapeLock() {
  try {
    await document.documentElement.requestFullscreen();
  } catch {
    return;
  }
  try {
    await navigator.keyboard?.lock(['Escape']);
  } catch {
    // Keyboard Lock unsupported/unavailable — Escape exits fullscreen as normal.
  }
}

export function exitAppFullscreen() {
  if (document.fullscreenElement) document.exitFullscreen().catch(() => {});
  try { navigator.keyboard?.unlock(); } catch {}
}
